import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Email } from '../../_kernel/Email'
import { Phone } from '../../_kernel/Phone'
import { countryDataSource } from '../../_datasource/CountryDatasource'
import type { Markets } from '../../shared/domain/Market'

export const FROM_MARKET_TO_SUPPORT_INFO: Record<Markets, { phone?: string; email: string }> =
  Object.values(countryDataSource).reduce(
    (acc, config) => {
      if (!acc[config.market]) {
        acc[config.market] = {
          ...(config.phone ? { phone: config.phone } : {}),
          email: config.contactEmail,
        }
      }
      return acc
    },
    {} as Record<Markets, { phone?: string; email: string }>
  )

export const SupportInfoValidation = z.object({
  phone: z.instanceof(Phone).optional(),
  email: z.instanceof(Email, { message: '[SupportInfo] email is required' }),
})

export class SupportInfo extends Model {
  static create({ phone, email }: z.infer<typeof SupportInfoValidation>) {
    SupportInfoValidation.parse({ phone, email })
    return new SupportInfo(email, phone)
  }

  static fromJSON(json: ReturnType<SupportInfo['toJSON']>) {
    return SupportInfo.create({
      phone: Phone.createOrUndefined({ value: json.phone }),
      email: Email.create({ value: json.email }),
    })
  }

  static fromJSONOrUndefined(json?: ReturnType<SupportInfo['toJSON']>) {
    try {
      if (!json) return undefined
      return SupportInfo.fromJSON(json)
    } catch {
      return undefined
    }
  }

  constructor(
    private readonly _email: Email,
    private readonly _phone?: Phone
  ) {
    super()
  }

  get phone() {
    return this._phone?.value
  }
  get email() {
    return this._email.value
  }

  isEmpty() {
    return this.phone === '' && this.email === ''
  }

  toJSON() {
    return { ...(this.phone && { phone: this.phone }), email: this.email }
  }
}
